import CompLayout from "@/pcomponents/comp/layout/layout";
import { useState } from 'react';
import PointListArea from "@/pages/comp/basic/point/common/point_use_list";
import PointOrderListArea from "@/pages/comp/basic/point/common/point_order_list";
import SelectTab from "@/pcomponents/common/crud/write/select_tab";
import { useLocation } from "react-router";

function PointUseListPage(props: any) {
  let myProps = {
    ...props
  };
  const { state } = useLocation();
  let default_tab="list";
  if(state&&state.tab){
    default_tab=state.tab;
  }
  const [page_tab, set_page_tab] = useState(default_tab);
  let page_tab_arr = [
    { text: "내역", value: "list" },
    { text: "충전주문", value: "list_order" },
  ];

  return (
    <CompLayout>
      <div>
        <div style={{ display: "inline-block" }}>
          <SelectTab
            select_arr={page_tab_arr}
            value={page_tab}
            is_same_value_empty={false}
            on_select={(value: string) => {
              set_page_tab(value);
            }}
            item_style={{ padding: "0px 12px", fontSize: "15px" }}
          ></SelectTab>
        </div>
      </div>
      <div className="mt-1">
        {page_tab == "list" &&
          <PointListArea></PointListArea>
        }
        {page_tab == "list_order" &&
          <PointOrderListArea></PointOrderListArea>
        }
      </div>
    </CompLayout>
  );
};
export default PointUseListPage;